import { Button, Stack, Typography } from "@mui/material";
import Title from "../../ui/Title";
import { Add } from "@mui/icons-material";
import CustomDataTable from "../../ui/CustomDataTable";
import { Card } from "../../ui/Card";
import { StyledSeperator } from "../../ui/Seperator";
import { useEffect, useState } from "react";
import {
  CustomerDetailsType,
  getCustomerApi,
  getCustomerDetailsApi,
} from "./setupApi";
import { useNavigate } from "react-router-dom";
import { StyledButton } from "../../ui/StyledButton";

const customerColumn = [
  {
    field: "person_name",
    headerName: "Name",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: any }) => (
      <>
        <Typography>{params.row?.person_name}</Typography>
      </>
    ),
  },
  {
    field: "mobile_numebr",
    headerName: "Phone Number",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "address",
    headerName: "Address",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 160,
    flex: 1,
  },
  {
    field: "action",
    headerName: "Action",
    minWidth: 160,
    flex: 1,
    renderCell: (params: { row: any }) => (
      <>
        <ViewDetails mobileNumber={params.row?.mobile_numebr} />
      </>
    ),
  },
];

const ViewDetails = ({ mobileNumber }: { mobileNumber: string }) => {
  const navigate = useNavigate();
  return (
    <StyledButton
      onClick={() =>
        navigate(`/set-up-and-management/customer_search/${mobileNumber}`)
      }
      sx={{
        textTransform: "none",
      }}
      variant="contained"
    >
      View details
    </StyledButton>
  );
};

const Customer = () => {
  const [customerData, setCustomerData] = useState<CustomerDetailsType[]>([]);

  useEffect(() => {
    getCustomerApi()
      .then((data) => {
        const finalData: CustomerDetailsType[] = data?.data?.data;
        finalData?.map((el, index) => {
          el.id = index + 1;
        });
        setCustomerData(finalData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Title title="All Customer" />
      </Stack>

      <StyledSeperator />

      <Card>
        <CustomDataTable
          total={customerData.length ?? 0}
          rows={customerData ?? []}
          columns={customerColumn}
        />
      </Card>
    </>
  );
};

export default Customer;
